import { Minus, Plus } from "lucide-react";

export const QuantityStepper = ({ value, onChange, testId }) => (
  <div className="inline-flex items-center rounded-sm border border-border bg-white" data-testid={testId}>
    <button
      type="button"
      aria-label="Decrease quantity"
      data-testid={`${testId}-decrease`}
      onClick={() => onChange(Math.max(0, value - 1))}
      className="flex h-8 w-8 items-center justify-center text-muted-foreground transition-colors hover:bg-muted hover:text-primary"
    >
      <Minus className="h-3.5 w-3.5" />
    </button>
    <span className="w-8 text-center text-sm font-medium tabular-nums" data-testid={`${testId}-value`}>
      {value}
    </span>
    <button
      type="button"
      aria-label="Increase quantity"
      data-testid={`${testId}-increase`}
      onClick={() => onChange(value + 1)}
      className="flex h-8 w-8 items-center justify-center text-muted-foreground transition-colors hover:bg-muted hover:text-primary"
    >
      <Plus className="h-3.5 w-3.5" />
    </button>
  </div>
);
